<section class="dashboard-main container-fluid" *ngIf="loader">
    <div class="loaderwrapper">
        <span class="loader"></span>
    </div>
</section>

<!-- No access card, shown instead of a page the role cannot view -->
<section class="dashboard-main container-fluid" *ngIf="permissionsReady && !permissions.canView">
    <div class="no-access-wrapper">
        <div class="no-access-card">
            <h4>No Access</h4>
            <p class="mb-0">You don't have permission to view Field Service Reports.</p>
        </div>
    </div>
</section>

<ng-container *ngIf="permissionsReady && permissions.canView">
    <section class="contents-main">
        <div class="container-fluid p-0">
            <div class="card table-card pt-0 m-0">
                <div class="table-toolbar">
                    <h1 class="table-toolbar__title">Field Service Report</h1>
                    <div class="sb-filter-holder sb-filter-holder--inline">
                        <!-- Job Type -->
                        <div class="input-wrapper">
                            <ng-select (change)="selectJobType($event)" placeholder="Job Type"
                                class="sb-filter-field sb-filter-field--md">
                                <ng-option *ngFor="let item of jobVisitTypes" [value]="item.id">{{ item.name }}
                                </ng-option>
                            </ng-select>
                        </div>
                        <!-- Status -->
                        <div class="input-wrapper">
                            <ng-select (change)="selectStatus($event)" placeholder="Status"
                                class="sb-filter-field sb-filter-field--md">
                                <ng-option *ngFor="let item of statusFilterList" [value]="item.id">{{ item.name }}
                                </ng-option>
                            </ng-select>
                        </div>
                        <!-- City — matches the city/region shown in the Location column.
                             ng-option carries the id as its value; with [items]+bindValue
                             ng-select's (change) emits the whole object instead. -->
                        <div class="input-wrapper">
                            <ng-select (change)="selectCity($event)" placeholder="City" notFoundText="No city found"
                                class="sb-filter-field sb-filter-field--md">
                                <ng-option *ngFor="let item of cityList" [value]="item.id">{{ item.name }}
                                </ng-option>
                            </ng-select>
                        </div>
                        <!-- ZC Staff -->
                        <div class="input-wrapper">
                            <ng-select (change)="selectAssignee($event)" placeholder="ZC Staff"
                                class="sb-filter-field sb-filter-field--md">
                                <ng-option *ngFor="let item of assignedUsersFilter" [value]="item.id">{{
                                    item.first_name }}</ng-option>
                            </ng-select>
                        </div>
                        <!-- Search -->
                        <div class="btn-group input-wrapper sb-filter-search-group" role="group">
                            <input type="text" class="sb-filter-field sb-filter-search-input" placeholder="Search"
                                (input)="searchData($event)">
                            <button type="button" class="btn sb-filter-search-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                    fill="none">
                                    <path
                                        d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M17.5 17.5L13.875 13.875" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <button type="button" class="btn btn-dark rounded" (click)="addNewFsr(fsrModal)"
                        *ngIf="permissions.canAdd">
                        <i class="ri-add-line label-icon align-middle fs-16"></i>
                        Add Service Report
                    </button>
                </div>

                <div class="datatable-container position-relative">
                    <div class="loaderwrapper" *ngIf="isLoadingTable">
                        <span class="loader"></span>
                    </div>
                    <ngx-datatable class="material expandable table-responsive" [rows]="fsrList" [headerHeight]="50"
                        [footerHeight]="0" [rowHeight]="'auto'" [columnMode]="'force'" [scrollbarH]="true"
                        [externalSorting]="true" [messages]="{ emptyMessage: 'No FSR found.' }" (sort)="onSort($event)">

                        <ngx-datatable-column name="Sr No." [sortable]="false" [width]="70">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                {{ row.srNo }}
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- Job ID carries the report serial as a sub-line, so the
                             serial needs no column of its own. Sorted on serial_seq
                             because '0002-25' sorts above '0001-26' as a string. -->
                        <ngx-datatable-column name="Job ID" [sortable]="true" [prop]="'job_id'" [width]="110">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span class="d-block">{{ row.job_id }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Report Serial No" [sortable]="true" [prop]="'report_serial_no'"
                            [width]="110">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span class="d-block">{{ row.report_serial_no }}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Customer Name" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                {{ row.customer_detail?.full_name || '-' }}
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- Plant name, with its city/region beneath -->
                        <ngx-datatable-column name="Location" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span class="d-block">{{ row.plant?.stationName || '-' }}</span>
                                <small class="text-muted" *ngIf="row.plant_city || row.plant_region">
                                    {{ locationSubtitle(row) }}
                                </small>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Visit Date" [sortable]="true" [prop]="'visit_date'">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                {{ row.visit_date ? (row.visit_date | date: 'mediumDate') : '-' }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="ZC Staff Name" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                {{ row.assigned_to?.first_name || '-' }}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Job Type" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                {{ row.job_visit_type_display }}
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- Approval folds into this badge: an approved FSR reads
                             "Approved" in green rather than taking its own column. -->
                        <ngx-datatable-column name="Current Status" [sortable]="true" [prop]="'status'">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span class="badge badge-custom badge-sm" [ngClass]="statusBadge(row)">
                                    {{ statusLabel(row) }}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Actions" [sortable]="false" [minWidth]="'5%'">
                            <ng-template ngx-datatable-header-template>
                                <div class="w-100 text-end">Actions</div>
                            </ng-template>
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <ul class="list-inline hstack buttons gap-2 mb-0 flex-wrap justify-content-end">
                                    <!-- The row's next workflow step; Edit and the other actions sit in the menu. -->
                                    <li class="list-inline-item" *ngIf="nextAction(row) as next">
                                        <a [title]="actionLabels[next]" (click)="runRowAction(row, next)"
                                            class="btn btn-dark rounded small fsr-action-btn">{{ actionLabels[next] }}</a>
                                    </li>
                                    <li *ngIf="permissions.canView" class="list-inline-item" data-bs-toggle="tooltip"
                                        data-bs-trigger="hover" data-bs-placement="top" title="View">
                                        <a title="View" class="text-primary d-inline-block" (click)="viewFsr(row.id)">
                                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M7.5 3.3V7.5L10.3 8.9M7.5 0.5C11.364 0.5 14.5 3.636 14.5 7.5C14.5 11.364 11.364 14.5 7.5 14.5C3.636 14.5 0.5 11.364 0.5 7.5C0.5 3.636 3.636 0.5 7.5 0.5Z"
                                                    stroke="currentColor" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </a>
                                    </li>
                                    <li class="list-inline-item" *ngIf="canEditRow(row) || menuActions(row).length">
                                        <div ngbDropdown container="body" placement="bottom-end" class="d-inline-block">
                                            <button type="button" class="action-btn" ngbDropdownToggle aria-label="More actions">
                                                <svg width="3" height="14" viewBox="0 0 3 14" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M3 12.5165C3 12.9231 2.85278 13.272 2.55833 13.5632C2.26389 13.8544 1.91111 14 1.5 14C1.08889 14 0.736112 13.8544 0.441667 13.5632C0.147223 13.272 0 12.9231 0 12.5165C0 12.1099 0.147223 11.761 0.441667 11.4698C0.736112 11.1786 1.08889 11.033 1.5 11.033C1.77222 11.033 2.02222 11.1016 2.25 11.239C2.47778 11.3709 2.66111 11.5495 2.8 11.7747C2.93333 11.9945 3 12.2418 3 12.5165Z"
                                                        fill="#666666" />
                                                    <path
                                                        d="M3 7C3 7.40659 2.85278 7.75549 2.55833 8.0467C2.26389 8.33791 1.91111 8.48352 1.5 8.48352C1.08889 8.48352 0.736112 8.33791 0.441667 8.0467C0.147223 7.75549 0 7.40659 0 7C0 6.59341 0.147223 6.24451 0.441667 5.9533C0.736112 5.66209 1.08889 5.51648 1.5 5.51648C1.77222 5.51648 2.02222 5.58517 2.25 5.72253C2.47778 5.8544 2.66111 6.03297 2.8 6.25824C2.93333 6.47802 3 6.72527 3 7Z"
                                                        fill="#666666" />
                                                    <path
                                                        d="M3 1.48351C3 1.89011 2.85278 2.23901 2.55833 2.53022C2.26389 2.82143 1.91111 2.96703 1.5 2.96703C1.08889 2.96703 0.736112 2.82143 0.441667 2.53022C0.147223 2.23901 0 1.89011 0 1.48351C0 1.07692 0.147223 0.728022 0.441667 0.436812C0.736112 0.145604 1.08889 0 1.5 0C1.77222 0 2.02222 0.0686817 2.25 0.206044C2.47778 0.337913 2.66111 0.516483 2.8 0.741757C2.93333 0.961538 3 1.20879 3 1.48351Z"
                                                        fill="#666666" />
                                                </svg>
                                            </button>
                                            <div ngbDropdownMenu>
                                                <button type="button" ngbDropdownItem *ngIf="canEditRow(row)"
                                                    (click)="editFsr(fsrModal, row)">Edit</button>
                                                <button type="button" ngbDropdownItem *ngFor="let action of menuActions(row)"
                                                    (click)="runRowAction(row, action)">{{ actionLabels[action] }}</button>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>

                    <div class="table-meta">
                        <div class="entries flex-column align-items-start gap-3">
                            <label class="show-entries-list p-0">
                                Show
                                <select [formControl]="pageSizeControl" class="form-control form-control-sm"
                                    (change)="changePageSize()">
                                    <option *ngFor="let limit of pageRecordOptions" [value]="limit.value">
                                        {{ limit.label }}
                                    </option>
                                </select>
                                Entries
                            </label>
                            <span>Total Records: {{ total_items || 0 }}</span>
                        </div>
                        <nav class="table-pagination" *ngIf="total_pages > 0">
                            <ul>
                                <li>
                                    <div class="go-to-page d-flex align-items-center">
                                        <label>Go to Page:</label>
                                        <input type="number" class="form-control form-control-sm" [(ngModel)]="pageToGo"
                                            min="1" [max]="total_pages" (keydown.enter)="navigateToPage()">
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button" (click)="navigateToPage()"
                                                [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                                        </div>
                                    </div>
                                </li>
                                <li><a class="init-bg" (click)="goToPage(1)" [class.disabled]="current_page === 1">1</a>
                                </li>
                                <li><a class="no-bg" (click)="navigatePage('prev')"
                                        [class.disabled]="current_page === 1"><i class="fa fa-chevron-left"></i></a>
                                </li>
                                <li><a class="active">{{ current_page }}</a></li>
                                <li><a class="no-bg" (click)="navigatePage('next')"
                                        [class.disabled]="current_page === total_pages"><i
                                            class="fa fa-chevron-right"></i></a></li>
                                <li><a class="init-bg" (click)="goToPage(total_pages)"
                                        [class.disabled]="current_page === total_pages">{{ total_pages }}</a></li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </section>
</ng-container>

<!-- ======================= Create / Edit ======================= -->
<ng-template #fsrModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">{{ isEditMode ? 'Edit FSR' : 'Add Field Service Report' }}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" rx="12" fill="white" />
                <path d="M7 7.00024L12.0515 12.0518L17.103 7.00024" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.99995 17.6716L12.0505 12.6201L17.1021 17.6716" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="fsrForm" (ngSubmit)="save(oversizeModal)" novalidate>
            <app-fsr-form [form]="fsrForm" [plantList]="plantList" [jobVisitTypes]="jobVisitTypes"
                [complaintTypes]="complaintTypes" [customerList]="customerList" [staffList]="staffList" [files]="files"
                [existingAttachments]="existingAttachments" [reportSerialNo]="selectedFsr?.report_serial_no"
                [jobId]="selectedFsr?.job_id" (plantChange)="onPlantChange($event)" (fileChange)="addFsrFiles($event)"
                (fileRemove)="removeFile($event)" (addPanelGroup)="addPanelGroup()"
                (removePanelGroup)="removePanelGroup($event)">
            </app-fsr-form>
        </form>
    </div>
    <div class="modal-footer no-bg">
        <button type="button" class="btn btn-outline-dark" (click)="d('Cross click')">Cancel</button>
        <button type="button" class="btn btn-orange" (click)="save(oversizeModal)"
            [disabled]="fsrForm.invalid || isSaving">
            <span *ngIf="isSaving" class="spinner-border spinner-border-sm align-middle me-2"></span>
            {{ isSaving ? (isEditMode ? 'Updating...' : 'Saving...') : (isEditMode ? 'Update' : 'Save') }}
        </button>
    </div>
</ng-template>

<!-- ======================= Oversize upload warning ======================= -->
<ng-template #oversizeModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Attachments Exceed 100MB</h4>
    </div>
    <div class="modal-body" *ngIf="oversizeBreakdown">
        <p>
            The attachments total <b>{{ formatFileSize(oversizeBreakdown.total) }}</b>, which is over the
            100MB limit.
        </p>
        <ul class="mb-3">
            <li *ngIf="oversizeBreakdown.images.files.length">
                {{ oversizeBreakdown.images.files.length }} image(s) —
                {{ formatFileSize(oversizeBreakdown.images.bytes) }} <em>(can be compressed)</em>
            </li>
            <li *ngIf="oversizeBreakdown.videos.files.length">
                {{ oversizeBreakdown.videos.files.length }} video(s) —
                {{ formatFileSize(oversizeBreakdown.videos.bytes) }} <em>(can be compressed)</em>
            </li>
            <li *ngIf="oversizeBreakdown.others.files.length">
                {{ oversizeBreakdown.others.files.length }} document(s) —
                {{ formatFileSize(oversizeBreakdown.others.bytes) }}
                <em>(already compressed; cannot be shrunk further)</em>
            </li>
        </ul>
        <p class="mb-0" *ngIf="!oversizeBreakdown.nothingCompressible">
            Compress them to fit under 100MB?
        </p>
        <p class="mb-0 text-danger" *ngIf="oversizeBreakdown.nothingCompressible">
            None of these file types can be compressed. Please remove some attachments.
        </p>
    </div>
    <div class="modal-footer no-bg">
        <button type="button" class="btn btn-outline-dark" (click)="cancelOversizeUpload()">No</button>
        <button type="button" class="btn btn-orange" (click)="confirmCompressAndUpload()"
            [disabled]="oversizeBreakdown?.nothingCompressible">
            Yes, compress
        </button>
    </div>
</ng-template>

<!-- ======================= Assign ======================= -->
<ng-template #assignModal let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Assign FSR</h4>
    </div>
    <div class="modal-body">
        <p class="text-center">Assign {{ selectedFsr?.job_id }} to a ZC staff member.</p>
        <form [formGroup]="assignForm">
            <label>ZC Staff <span class="text-danger">*</span></label>
            <ng-select placeholder="Select a user" formControlName="assignee_id" [items]="staffList"
                bindLabel="full_name" bindValue="id">
            </ng-select>
            <small class="text-danger"
                *ngIf="assignForm.get('assignee_id')?.invalid && assignForm.get('assignee_id')?.touched">
                Please select a user
            </small>
        </form>
    </div>
    <div class="modal-footer no-bg">
        <button type="button" class="btn btn-outline-dark" (click)="d('Cross click')">No</button>
        <button type="button" class="btn btn-orange" (click)="assignFsr()"
            [disabled]="assignForm.invalid || loader">Yes</button>
    </div>
</ng-template>

<!-- ======================= Start ======================= -->
<ng-template #startModal let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Start FSR</h4>
    </div>
    <div class="modal-body">
        <p class="text-center mb-0">Start work on {{ selectedFsr?.job_id }}?</p>
    </div>
    <div class="modal-footer no-bg">
        <button type="button" class="btn btn-outline-dark" (click)="d('Cross click')">No</button>
        <button type="button" class="btn btn-orange" (click)="startFsr()" [disabled]="loader">Yes</button>
    </div>
</ng-template>

<!-- ======================= Resolve ======================= -->
<ng-template #resolveModal let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Resolve FSR</h4>
    </div>
    <div class="modal-body">
        <p class="text-center mb-0">Mark {{ selectedFsr?.job_id }} as resolved?</p>
    </div>
    <div class="modal-footer no-bg">
        <button type="button" class="btn btn-outline-dark" (click)="d('Cross click')">No</button>
        <button type="button" class="btn btn-orange" (click)="resolveFsr()" [disabled]="loader">Yes</button>
    </div>
</ng-template>

<!-- ======================= Approve ======================= -->
<ng-template #approveModal let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Approve FSR</h4>
    </div>
    <div class="modal-body">
        <p class="text-center">
            Approve {{ selectedFsr?.job_id }} and send the completion email to
            <b>{{ selectedFsr?.customer_detail?.full_name || 'the customer' }}</b>?
        </p>
        <p class="text-center text-danger mb-0" *ngIf="!selectedFsr?.customer">
            This FSR has no customer selected, so no email will be sent.
        </p>
    </div>
    <div class="modal-footer no-bg">
        <button type="button" class="btn btn-outline-dark" (click)="d('Cross click')">No</button>
        <button type="button" class="btn btn-orange" (click)="approveFsr()" [disabled]="loader">Yes, approve</button>
    </div>
</ng-template>

<!-- ======================= Reason-based actions =======================
     On Hold, Pending Material, Close, Reopen and Cancel differ only in their
     wording, so they share one body. `pendingAction` (set by openAction) picks
     the endpoint; see submitPendingAction(). -->
<ng-template #holdModal let-d="dismiss">
    <ng-container *ngTemplateOutlet="reasonBody;
        context: { title: 'On Hold FSR', prompt: 'move this FSR to on hold', dismiss: d }">
    </ng-container>
</ng-template>

<ng-template #pendingModal let-d="dismiss">
    <ng-container *ngTemplateOutlet="reasonBody;
        context: { title: 'Pending Material', prompt: 'mark this FSR as pending material', dismiss: d }">
    </ng-container>
</ng-template>

<ng-template #closeModal_ let-d="dismiss">
    <ng-container *ngTemplateOutlet="reasonBody;
        context: { title: 'Close FSR', prompt: 'close this FSR', dismiss: d }">
    </ng-container>
</ng-template>

<ng-template #reopenModal let-d="dismiss">
    <ng-container *ngTemplateOutlet="reasonBody;
        context: { title: 'Reopen FSR', prompt: 'reopen this FSR', dismiss: d }">
    </ng-container>
</ng-template>

<ng-template #cancelModal let-d="dismiss">
    <ng-container *ngTemplateOutlet="reasonBody;
        context: { title: 'Cancel FSR', prompt: 'cancel this FSR', dismiss: d }">
    </ng-container>
</ng-template>

<ng-template #reasonBody let-title="title" let-prompt="prompt" let-dismiss="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
    </div>
    <div class="modal-body">
        <p class="text-center">Are you sure you want to {{ prompt }} ({{ selectedFsr?.job_id }})?</p>
        <form [formGroup]="actionForm">
            <label>Reason <span class="text-danger">*</span></label>
            <textarea formControlName="reason" rows="3" class="form-control no-resize" maxlength="1000"
                style="height: 97px;"></textarea>
            <small class="text-danger" *ngIf="actionForm.get('reason')?.invalid && actionForm.get('reason')?.touched">
                <span *ngIf="actionForm.get('reason')?.errors?.['required']">Reason is required</span>
                <span *ngIf="actionForm.get('reason')?.errors?.['maxlength']">Maximum 1000 characters allowed</span>
            </small>
        </form>
    </div>
    <div class="modal-footer no-bg">
        <button type="button" class="btn btn-outline-dark" (click)="dismiss('Cross click')">No</button>
        <button type="button" class="btn btn-orange" (click)="submitPendingAction()"
            [disabled]="actionForm.invalid || loader">Yes</button>
    </div>
</ng-template>